import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu
} from "reactstrap";

//i18n
import { withTranslation } from "react-i18next";
// Redux
import { connect, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import withRouter from "../withRouter";

const ProfileMenu = (props) => {

  const [menu, setMenu] = useState(false);
  // const [dataUser, setDataUser] = useState(null);
  const {userProfile} = useSelector(state => ({
    userProfile: state.login.profile
  }))

  // useEffect(() => {
  //   if (localStorage.getItem("authUser")) {
  //     const obj = JSON.parse(localStorage.getItem("authUser"));
  //     setDataUser(obj.resultset_2[0])
  //   }
  // }, [props.success]);

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className={`px-3 header-item header-container-profile-user ${
            menu ? "active-dropdown" : ""
          }`}
          id="page-header-user-dropdown"
          tag="button"
        >
          {userProfile?.Foto_Usuario ? (
            <img
              className="rounded-circle border border-2 border-white header-profile-user"
              src={userProfile?.Foto_Usuario}
              alt="Header Avatar"
            />
          ) : (
            <div className="rounded-circle d-flex align-items-center justify-content-center border border-4 border-white">
              <i className="fas fa-user" style={{ fontSize: 22 }} />
            </div>
          )}
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end header-container-profile-user-dropdown-menu">
          <div className="info-profile container-infos">
            <span className="business-name">{userProfile?.Apelido || userProfile?.Nome_Completo}</span>
            <span className="business-description">{userProfile?.Email}</span>
          </div>
          <Link to="/BI_WS0002" onClick={() => {
            setMenu(false)
          }} className="dropdown-item">
            <i className="fas fa-user-tie text-primary"></i>
            Configurações do Usuário
          </Link>
          <Link to="/BI_WS0010" onClick={() => {
            setMenu(false)
          }} className="dropdown-item">
            <i className="fas fa-building text-primary"></i>
            Configurações da Empresa
          </Link>
          <Link to="/logout" className="dropdown-item">
            <i className="fas fa-sign-out-alt text-primary"></i>
            Sair
          </Link>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any,
};

const mapStatetoProps = (state) => {
  const { error, success } = state.profile;
  return { error, success };
};

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
);
